<template>
  <!--  普通登录页面-->
  <div class="login">
    <!-- 放logo的地方 -->
    <div class="login-logo">
      <div class="logo-img">
        <img src="./assets/Group.png" alt="" />
        <p class="logo-title">解析返回值</p>
        <div class="logo-title-intro">
          <p>输入后端api页面加密数据</p>
          <p>1</p>
          <p>2</p>
          <p>3</p>
        </div>
      </div>
    </div>
    <!-- 登录的操作部分 -->
    <div class="login-main">
      <div class="login-main-box">
        <!--返回按钮-->
        <div class="box-top">
          <div class="top-icon">
            <img src="./assets/Arrow_Right_LG.png" alt="" />
          </div>
        </div>

        <div class="bottom-box">
          <div class="bottom-box-title">
            <p class="welcom">Welcome Back!</p>
            <p class="ja-welcom">
              <span>输入加密数据：</span>
            </p>
          </div>
          <div class="box-form">
            <!-- 邮箱input -->
            <div class="emil-input">
              <p class="emil-input-title">
                输入
                <!-- <span v-if="emilShow" class="emil-true-css">{{
                }}</span> -->
              </p>
              <div class="emil-input-css">
                <img src="./assets/Vector (1).png" alt="" class="emil-icon" />
                <form class="form-input-css-main">
                  <input type="text" class="emil-input-css-main" v-model="vc"
                         @blur="inputData(1)"/>
                </form>
                <!-- 结果输出 -->
                <div class="form-text-area">
                  <div class="text-area-box">
                    <div class="one-box-title">
                    </div>
                    <div class="text-area-input">
                      <el-input type="textarea" :rows="2" v-model="jieguo">
                      </el-input>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 确定按钮 -->
              <div class="insure">
                <button class="insure-button" @click="login">
                  转换 </button>
              </div>
            </div>

            <!-- 忘记密码 -->
            <div class="forget">
              <p class="forget-main" @click="clear">
                清空 </p>
            </div>


          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { jiemidaxingdong } from "../../js/api";
import axios from "axios";
import jwtDecode from 'jwt-decode'
import AES from "../../js/AES";
export default {
  name: "Login",
  components: {},
  data() {
    return {
      jieguo: null, //结果
      vc: "", //验证码key
      registrationSuccess: false, //注册成功标识

    };
  },
  created() {

  },
  computed: {},
  mounted() { },
  methods: {
    // input校验
    inputData(num) {
      var vc = /^.{1,999}$/;
      var vc2 = /^.{1,32}$/;
      var vc3 = /^.{1,64}$/;

      if (num === 1) {
        if (vc.test(this.vc)) {
        }
        else {
          this.$message.error('输入字数超过限制999位。');
        }
      } else if (num === 2) {
        if (vc2.test(this.vc2)) {
        } else {
          this.$message.error('输入字数超过限制32位。');
        }
      } else if (num === 3) {
        if (this.vc3 !== this.vc3) {
        } else {
          this.$message.error('输入字数超过限制64位。');
        }
      }
    },


    //切换语言
    handleCommand(command) {
      if (command === "0") {
        this.$i18n.locale = "zh-CN";
        this.lang = "CN";
      } else {
        this.$i18n.locale = "ja-JP";
        this.lang = "JP";
      }
    },

    //解密
    login() {
      console.log(this.vc)
      console.log("----解密星星----" + this.vc)
      const aesFecInfo = JSON.parse(AES.decrypt(this.vc));
      console.log(aesFecInfo)
      this.jieguo = JSON.stringify(aesFecInfo)
    },
    //clear
    clear(){
      this.vc=""
      this.jieguo = null
    }
  },
};
</script>
<style scoped>


/*.login-dialog {*/
/*  width: 100vw;*/
/*  height: 100vh;*/
/*  position: absolute;*/
/*  top: 0;*/
/*  left: 0;*/
/*  display: flex;*/
/*  justify-content: center;*/
/*  align-items: center;*/
/*  background: rgba(0, 0, 0, 0.6);*/
/*}*/

/*.dialog-main {*/
/*  width: 498px;*/
/*  height: 266px;*/
/*  background: #fff;*/
/*  display: flex;*/
/*  flex-direction: column;*/
/*  align-items: center;*/
/*  box-shadow: 0 12px 5px -10px rgba(0, 0, 0, 0.1), 0 0 4px 0 rgba(0, 0, 0, 0.1);*/
/*}*/


/*.dialog-main img {*/
/*width: 66px;*/
/*height: 66px;*/
/*margin-bottom: 30px;*/
/*margin-top: 37px;*/
/*}*/

.login {
  width: 100vw;
  height: 100vh;
  background: #51abff;
  display: flex;
  position: relative;
}

.forget-password {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.password-dialog {
  width: 498px;
  height: 266px;
  background: #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  padding: 15px;
  box-sizing: border-box;
}

.dialog-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 34px;
  color: #686868;
}

.dialog-hint {
  margin-left: 17px;
  width: 434px;
  height: 48px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #686868;
  margin-top: 13px;
}

.dialog-emil-input {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 560px;
}

.dialog-emil-button {
  width: 118px;
  height: 24px;
  line-height: 24px;
  background: #ffffff;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
  color: #51abff;
}

.dialog-emil-hint {
  margin-top: 5px;
  text-align: right;
  padding-right: 15px;
  box-sizing: border-box;
  color: #f56c6c;
}

.dialog-button-css {
  text-align: center;
  margin-top: 20px;
}

.login-logo {
  height: 100vh;
  width: 50vw;
  padding: 250px 0 0 110px;
  box-sizing: border-box;
}

.logo-title {
  font-family: "Mochiy Pop P One";
  font-style: normal;
  font-weight: 400;
  font-size: 96px;
  line-height: 139px;
  color: #ffffff;
  margin-top: -25px;
}

.logo-title-intro {
  width: 312px;
  height: 176px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 40px;
  color: #ffffff;
  margin-top: 36px;
}

.login-main {
  flex: 1;
  background: #ffffff;
  position: relative;
}

.login-main-box {
  position: absolute;
  width: 504px;
  height: 750px;
  top: 30%;
  left: 50%;
  margin-left: -202px;
  margin-top: -275px;
  background: #ffffff;
  border: 2px solid #ececec;
  box-sizing: border-box;
  border-radius: 8px;
}

.box-top {
  height: 50px;
  line-height: 50px;
  width: 100%;
}

.top-icon {
  width: 50px;
  height: 50px;
  float: right;
  text-align: center;
  cursor: pointer;
}

.bottom-box {
  height: 438px;
  padding: 0 40px;
  box-sizing: border-box;
}

.bottom-box-title {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 324px;
  height: 56px;
}

.welcom {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  align-items: center;
  text-align: center;
  color: #98989e;
  margin: 3px 0px;
}

.ja-welcom {
  width: 100%;
  height: 32px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #212429;
  display: flex;
}

.lang-dropdown {
  margin-left: 10px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13.6333px;
  line-height: 16px;
  letter-spacing: 0.639063px;
  color: #686868;
  padding-top: 12px;
  box-sizing: border-box;
}

.el-dropdown-link {
  cursor: pointer;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.box-form {
  margin-top: 40px;
  height: 750px;

}

.emil-input {
  padding: 0px;
  width: 324px;
  height: 500px;
  margin-bottom: 10px;
}

.emil-input-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #686868;
  margin: 8px 0px;
}

.emil-input-css {
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  border-radius: 24px;
  height: 40px;
  width: 320px;
  box-sizing: border-box;
}

.emil-input-css img {
  margin-top: 13px;
}

.code-input-css {
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  border-radius: 24px;
  height: 40px;
  width: 180px;
  box-sizing: border-box;
}

.code-main-css-flex {
  display: flex;
}

.code-img-main {
  background: #f1f1f1;
  width: 100px;
  height: 40px;
  margin-left: 25px;
}

.code-img-url {
  width: 100px;
  height: 40px;
}

.emil-icon {
  margin-right: 10px;
  margin-left: 15px;
}

.emil-input-css-main {
  width: 240px;
  margin-right: 10px;
  height: 34px;
  line-height: 34px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  color: #c9cfda;
}

.form-input-css-main {
  width: 240px;
  margin-right: 10px;
  height: 34px;
  float: right;
  margin-top: 2px;
}

.code-input-css-main {
  width: 110px;
  height: 34px;
  line-height: 34px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  color: #c9cfda;
}

.form-input-css-password {
  width: 110px;
  height: 34px;
  line-height: 34px;
  margin-top: 2px;
  margin-right: 10px;
  float: right;
}

.code-input-css img {
  margin-top: 12px;
}

.forget {
  overflow: hidden;
  margin-top: 30px;
}

.forget-main {
  width: 120px;
  float: right;
  text-align: right;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  letter-spacing: -0.02em;
  color: #51abff;
  cursor: pointer;
}

.insure {
  height: 50px;
  margin-top: 50px;
  margin-bottom: 10px;
}

.insure-button {
  background: #fc630c;
  border-radius: 24px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 23px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #ffffff;
  width: 320px;
  height: 50px;
  margin-top: 400px;
}

.form-text-area {
  height: 158px;
  box-sizing: border-box;
  margin-top: 50px;
}

.text-area-box {
  width: 400px;
  height: 400px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  position: absolute;
}

.text-area-input {
  margin-top: 10px;
}

.text-area-input /deep/ .el-textarea__inner {
  border: 1px solid transparent;
  height: 360px;
}
</style>



// WEBPACK FOOTER //
// src/pages/decryptBackendReturnValue/index.vue